module.exports = __webpack_public_path__ + "img/menu_open-black.cd086281.svg";